import React from "react";
import { Link } from "react-router-dom";

import ReactGA from "react-ga";

import { Icon } from "app/NativeComponents/common";

const FeatureCTA = ({ children, to, slug = null, style, onPress }) => {
  return (
    <Link
      to={to}
      className="dm-website-feature-cta"
      style={style}
      onClick={ev => {
        if (onPress) {
          onPress();
        }

        //track click function
        if (slug) {
          ReactGA.event({
            category: "CTA",
            action: slug
          });
        }
      }}
    >
      <div>
        <span>{children}</span>
        <Icon icon={"arrow-forward"} size={20} />
      </div>
    </Link>
  );
};

export { FeatureCTA };
